import React from 'react';
import FinanciarFunctions from './FinanciarFunctions';
import Chart from 'react-apexcharts'


export default class ChartFurnizori extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            series: [{
                data: this.props.bilanturi.map((b) => {
                    return this.f.solduriFurnizori(b)
                })
            }],

            options: {
               
                chart: {
                    height: 350,
                    width:'90%',
                    type: 'bar',
                    events: {
                        click: function (chart, w, e) {
                            // console.log(chart, w, e)
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                colors: ['#ebbe4a'],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        distributed: true,
                        dataLabels: {
                            position: 'bottom', // top, center, bottom,
                           
                        },
                    }
                },
                dataLabels: {
                    enabled: false,
                    formatter: function (val, { seriesIndex, dataPointIndex, w }) {
                        console.log('idx :>> ', seriesIndex);
                        console.log('dataPointIndex :>> ', dataPointIndex);
                        console.log('w :>> ', w);
                        console.log('val :>> ', val);
                        return props.bilanturi[dataPointIndex]['an']

                    },
                    offsetY: 20,
                    style:{
                        colors:['#333']
                    }
                },
                legend: {
                    show: true,
                 
                },
                xaxis: {
                    categories:

                        this.props.bilanturi.map((b) => {
                            return [b.an]
                        }),

                        
                        // ['Solduri Clienti'],
                    // [
                    //   ['John', 'Doe'],
                    //   ['Joe', 'Smith'],
                    //   ['Jake', 'Williams'],
                    //   'Amber',
                    //   ['Peter', 'Brown'],
                    //   ['Mary', 'Evans'],
                    //   ['David', 'Wilson'],
                    //   ['Lily', 'Roberts'], 
                    // ],
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                }
            },

        }
    }

    componentDidMount() {
    }


    f = new FinanciarFunctions()
    render() {
        return (
            <div style={{ background: 'white' }} id="chart">


                <Chart
                    style={{ margin: 'auto' }}
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    width="90%"
                    height={400}
                />


            </div>
        );
    }
}